import { FC } from 'react';
import Card from '@/components/card';
import FormSection from '@/components/form/form-section';
import { FormHandle } from '@/hooks/use-form-handle.hook';
import { PolicyModel } from '@/lib/models/policy-model/policy.model';
import ContentControlItem from '../content-controls/item';
import LicenseControlItem from './license-control-item';
import DataPrivacyItem from './data-privacy-item';
import FormSectionSubtitle from '@/components/form/form-section/form-section-subtitle';

interface Props {
  policy: PolicyModel;
  formHandle: FormHandle<PolicyModel>;
  readonly: boolean;
  withNotSet?: boolean;
}

const ServiceControls: FC<Props> = ({ formHandle, readonly, policy, withNotSet = true }) => {
  return (
    <FormSection title="Service Metadata Controls" scrollId="service-controls">
      <FormSectionSubtitle>
        Choose what action is taken for requests matching different service metadata criteria.
      </FormSectionSubtitle>
      <Card>
        <LicenseControlItem formHandle={formHandle} readonly={readonly} withNotSet={withNotSet} />
        <DataPrivacyItem formHandle={formHandle} readonly={readonly} withNotSet={withNotSet} />
        <ContentControlItem
          controlType="file-upload"
          formHandle={formHandle}
          readonly={readonly}
          policy={policy}
          withNotSet={withNotSet}
        />
      </Card>
    </FormSection>
  );
};

export default ServiceControls;
